import { Perimeter } from 'vue-kindergarten';

export default class BasePerimeter extends Perimeter {
  isAdmin() {
    return this.child && this.child.role === 1;
  }
  isCRM() {
    return this.child && this.child.role === 2;
  }
  isERR() {
    return this.child && this.child.role === 3;
  }
  isEDB() {
    return this.child && this.child.role === 4;
  }
  isFDP() {
    return this.child && this.child.role === 5;
  }
}



// WEBPACK FOOTER //
// ./src/perimeters/basePerimeter.js